
export const DEFAULT_DROPDOWN_CONFIG: any = {
    highlight: false,
    create: false,
    persist: true,
    plugins: ['dropdown_direction', 'remove_button'],
    dropdownDirection: 'auto'
};

export const MULTI_SELECT_CONFIG_SearchBy: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'name',
    valueField: 'value',
    searchField: ['value'],
    plugins: ['remove_button'],
    minItems: 1,
    maxItems: 1000
}); 


// WEBPACK FOOTER //
// ./src/app/customerservice/selectize/selectize.searchBy.config.ts